import { useAuthStore } from '../stores/authStore';
import { useIsSuperAdmin } from './useIsSuperAdmin';

/**
 * Can the current user set a client INACTIVE? Deactivating takes the client off the
 * roster, so the API requires org-wide reach (`clients:manage:all` or super admin)
 * and 403s a caseload-scoped caller, who would otherwise lose every read path to the
 * record. Every status control asks this one question (ADO #584).
 */
export function useCanSetClientInactive(): boolean {
  const hasPermission = useAuthStore((s) => s.hasPermission);
  const isSuperAdmin = useIsSuperAdmin();
  return hasPermission('clients:manage:all') || isSuperAdmin;
}
